<!-- header -->
<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'CASES'" [breadcrumb]="breadcrumb"
  [isStringLiteral]="stringLiteralBreadcrumb" [count]="total" icon="fa-folders">
</app-breadcrumb>
<!-- body -->
<div class="content-background">
  <div class="row">
    <div class="col-sm-12">
      <div class="inputWithIcon inputWithIcon-search float-right d-flex">
        <app-advanced-mode id="caseGridAdvancedSwitch" [storageKey]="'cases-list'"
          (collapsibleToggle)="toggleAdvanced($event)">
        </app-advanced-mode>
        <input #search kendoTextBox class="ml-4 button-search" placeholder="{{ 'SEARCH-CASE' | translate }}"
          title="{{ 'SEARCH-CASE' | translate }}" [formControl]="searchControl" />
        <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
      </div>
    </div>
  </div>
  <div class="mt-3">
    <!-- cases data grid -->
    <kendo-grid #grid *ngIf="columnsConfig && columnsConfig.length > 0" [data]="gridView" [navigable]="true"
      [pageable]="isRestrictedPaging ? true : (total > state.take ? { buttonCount: 5, pageSizes: pageSizes } : false)"
      [pageSize]="state.take" [skip]="state.skip" [loading]="loading" [sort]="state.sort" [filter]="state.filter"
      [sortable]="true" [filterable]="enableAdvanced" [columnMenu]="enableAdvanced" [resizable]="true"
      [reorderable]="enableAdvanced" [selectedKeys]="selectedCaseKeys"
      [selectable]="{ checkboxOnly: enableAdvanced, mode: (enableAdvanced ? 'multiple' : 'single') }"
      [kendoGridSelectBy]="'id'" (dataStateChange)="dataStateChange($event)"
      (selectedKeysChange)="onSelectedKeysChange($event)" (columnVisibilityChange)="onVisibilityChange($event)"
      (columnResize)="onResize($event)" (columnReorder)="onReorder($event)" (pageChange)="pageChange($event)">
      <kendo-grid-messages noRecords="{{ 'NO-CASES' | translate }}">
      </kendo-grid-messages>
      <kendo-grid-checkbox-column *ngIf="enableAdvanced" [columnMenu]="false" [showSelectAll]="true" [width]="40"
        class="text-center" headerClass="text-center">
        <ng-template kendoGridHeaderTemplate>
          <div class="w-100">
            <input id="selectAllCheckboxId" kendoGridSelectAllCheckbox [state]="selectAllState"
              (selectAllChange)="onSelectAllChange($event)" type="checkbox" kendoCheckBox
              attr.aria-label="{{'SELECT-ELEMENT' | translate}}" />
            <label class="k-checkbox-label" for="selectAllCheckboxId"></label>
          </div>
        </ng-template>
        <ng-template kendoGridCellTemplate let-idx="rowIndex" let-dataItem>
          <input *ngIf="dataItem.status === 'Open'" [kendoGridSelectionCheckbox]="idx" type="checkbox" kendoCheckBox
            attr.aria-label="{{'SELECT-CASE' | translate}}" />
        </ng-template>
      </kendo-grid-checkbox-column>
      <ng-template kendoGridToolbarTemplate [position]="'top'" *ngIf="enableAdvanced">
        <button kendoButton (click)="refresh()" class="float-right">{{'GRID-REFRESH' | translate }}<i
            class="far fa-sync-alt mt-1"></i>
        </button>
        <button kendoButton (click)="resetGridColumns()" class="float-right">{{'RESET-GRID-COLUMNS' | translate }}
        </button>
        <button kendoButton (click)="filterDialogOpened=true">{{ 'SAVE-FILTER' | translate }}</button>
        <button class="float-right" kendoButton [primary]="true" type="button"
          [disabled]="selectedCaseKeys.length === 0" (click)="openCloseCasesDialogOpened()">
          {{'CLOSE-CASES' | translate }}<span *ngIf="getSelectedCount() > 0"
            class="ml-1">({{getSelectedCount()}})</span>
        </button>
        <button class="float-right" kendoButton [primary]="true" type="button"
          [disabled]="selectedCaseKeys.length === 0" (click)="openReassignCasesDialogOpened()">
          {{'REASSIGN-CASES' | translate }}<span *ngIf="getSelectedCount() > 0"
            class="ml-1">({{getSelectedCount()}})</span>
        </button>
      </ng-template>
      <kendo-grid-column *ngFor="let col of columnsConfig" [field]="col.field" [title]="col.title" [width]="col.width"
        [format]="col.format" [filterable]="col.filterable !== undefined ? col.filterable : true" [filter]="col.filter"
        [sortable]="col.sortable !== undefined ? col.sortable : true"
        [columnMenu]="col.columnMenu !== undefined ? col.columnMenu : true"
        [class]="col.class !== undefined ? (col.class + ' grid-column-'+col.field.replace('.','-')) : 'grid-column-'+col.field.replace('.','-')"
        [hidden]="col.hidden !== undefined ? col.hidden : false">
        <!--member-->
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'name'">
          <a [routerLink]="['/case', dataItem.id]" [queryParams]="{breadcrumb: breadcrumb}" class="pointer">
            {{ dataItem.name }}
          </a>
        </ng-template>
        <!--channel-->
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'channel'">
          <span title="{{dataItem.channel}}">{{dataItem.channel}}</span>
        </ng-template>
        <!--channel.program-->
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'channel.program'">
          <span title="{{dataItem.program}}">{{dataItem.program}}</span>
        </ng-template>
        <!--manager-->
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'manager'">
          {{dataItem.manager}}
          <span *ngIf="dataItem.status==='Open'">
            <a *ngxPermissionsOnly="['ROLE_OPERATOR','ROLE_PROGRAM_LEAD', 'ROLE_PROGRAM_SUPPORT']" class="pointer float-right mr-2"
              title="{{'REASSIGN' | translate}}" (click)="assignCaseManager(dataItem)">
              <i class="fas fa-undo icon-info"></i>
            </a>
          </span>
        </ng-template>
        <!--organizationName-->
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'organizationName'">
          <span>{{dataItem.organizationName}}</span>
        </ng-template>
        <!--openedOn-->
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field === 'openedOn'">
          <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="gte">
            <kendo-filter-eq-operator></kendo-filter-eq-operator>
            <kendo-filter-neq-operator></kendo-filter-neq-operator>
            <kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
            <kendo-filter-after-operator></kendo-filter-after-operator>
            <kendo-filter-before-eq-operator></kendo-filter-before-eq-operator>
            <kendo-filter-before-operator></kendo-filter-before-operator>
          </kendo-grid-date-filter-cell>
        </ng-template>
        <!--compositeRiskScore-->
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column"
          *ngIf="col.field === 'compositeRiskScore'">
          <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" operator="gte" [spinners]="false">
            <kendo-filter-eq-operator></kendo-filter-eq-operator>
            <kendo-filter-neq-operator></kendo-filter-neq-operator>
            <kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
            <kendo-filter-after-operator></kendo-filter-after-operator>
            <kendo-filter-before-eq-operator></kendo-filter-before-eq-operator>
            <kendo-filter-before-operator></kendo-filter-before-operator>
            <kendo-filter-isnull-operator></kendo-filter-isnull-operator>
            <kendo-filter-isnotnull-operator></kendo-filter-isnotnull-operator>
          </kendo-grid-numeric-filter-cell>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'openedOn'">
          <div *ngIf="dataItem.openedOn !== null">
            {{ intl.formatDate(intl.parseDate(dataItem.openedOn), 'g') }}
          </div>
        </ng-template>
        <!--closedOn-->
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field === 'closedOn'">
          <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="gte">
            <kendo-filter-eq-operator></kendo-filter-eq-operator>
            <kendo-filter-neq-operator></kendo-filter-neq-operator>
            <kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
            <kendo-filter-after-operator></kendo-filter-after-operator>
            <kendo-filter-before-eq-operator></kendo-filter-before-eq-operator>
            <kendo-filter-before-operator></kendo-filter-before-operator>
          </kendo-grid-date-filter-cell>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'closedOn'">
          <div *ngIf="dataItem.closedOn !== null">
            {{ intl.formatDate(intl.parseDate(dataItem.closedOn), 'g') }}
          </div>
        </ng-template>
        <!--history.lastActivityOn-->
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column"
          *ngIf="col.field === 'history.lastActivityOn'">
          <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="gte">
            <kendo-filter-eq-operator></kendo-filter-eq-operator>
            <kendo-filter-neq-operator></kendo-filter-neq-operator>
            <kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
            <kendo-filter-after-operator></kendo-filter-after-operator>
            <kendo-filter-before-eq-operator></kendo-filter-before-eq-operator>
            <kendo-filter-before-operator></kendo-filter-before-operator>
          </kendo-grid-date-filter-cell>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'history.lastActivityOn'">
          <div *ngIf="dataItem.history !== null && dataItem.history.lastActivityOn !== null">
            {{ intl.formatDate(intl.parseDate(dataItem.history.lastActivityOn), 'g') }}
          </div>
        </ng-template>
        <!--id-->
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'id'">
          {{dataItem.id}}
        </ng-template>
        <!--status-->
        <ng-template kendoGridFilterCellTemplate let-filter *ngIf="col.field === 'status'">
          <app-dropdown-filter [filter]="filter" [data]="distinctStatus" filterField="status"
            selectDefaultText="{{ 'SELECT-STATUS' | translate }}" textField="statusName" valueField="status"
            ariaLabel="{{ 'STATUS' | translate }}">
          </app-dropdown-filter>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'status'">
          {{dataItem.status | uppercase | translate}}
        </ng-template>
        <!--priority-->
        <ng-template kendoGridFilterCellTemplate let-filter *ngIf="col.field === 'priority'">
          <app-dropdown-filter [filter]="filter" [data]="distinctPriorities" filterField="priority"
            ariaLabel="{{ 'PRIORITY' | translate }}" selectDefaultText="{{ 'SELECT-PRIORITY' | translate }}"
            textField="priorityName" valueField="priority">
          </app-dropdown-filter>
        </ng-template>
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.filter === 'numeric'">
          <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" [spinners]="false">
          </kendo-grid-numeric-filter-cell>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'priority'">
          <div [className]="dataItem.priorityBadgeClass">{{ dataItem.priorityLetter }}</div>
        </ng-template>
      </kendo-grid-column>
      <ng-template kendoPagerTemplate *ngIf="isRestrictedPaging">
        <kendo-pager-page-sizes [pageSizes]="pageSizes"></kendo-pager-page-sizes>
      </ng-template>
    </kendo-grid>
  </div>
</div>

<!-- save filter dialog -->
<app-save-filter [dialogOpened]="filterDialogOpened" [filterCategory]="'Case'" [filterState]="state"
  [filterColumns]="columnsConfig" (cancelling)="filterDialogOpened=false;" [filter]="filterSelected">
</app-save-filter>

<!-- case assignment dialog -->
<kendo-dialog *ngIf="assigneeDialogOpened" title="{{'ASSIGN-CASE-TITLE' | translate}}"
  (close)="assigneeDialogOpened = false;" [minWidth]="350">
  <app-case-assign [aCase]="aCase" #caseAssign></app-case-assign>
  <kendo-dialog-actions>
    <button kendoButton (click)="assigneeDialogOpened = false;">{{'CANCEL' | translate}}</button>
    <button appPreventClick id="btnSaveChangeCaseManagerCaseList" kendoButton
      (click)="caseAssign.save(); assigneeDialogOpened = false;"
      [disabled]="caseAssign.caseManagerForm.invalid">{{'SAVE' | translate}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- close cases dialog -->
<kendo-dialog *ngIf="closeCasesDialogOpened" (close)="cancelCloseCases()" [minWidth]="450" [width]="900">
  <kendo-dialog-titlebar>
    <h3>{{'CLOSE-CASES' | translate}}</h3>
  </kendo-dialog-titlebar>
  <div class="p-2">
    <div class="form-group pl-1 pr-1">
      <label for="reasonForCloseCase" class="k-text-uppercase dark w-100">{{'REASON-FOR-CLOSE-CASES' | translate}} *
        <textarea id="reasonForCloseCase" required class="w-100" kendoTextArea rows="3" [(ngModel)]="reasonForClose"
          style="max-height: 400px;" maxlength="512">
        </textarea>
      </label>
    </div>
    <div class="form-group pl-1 pr-1" *ngIf="workflowStatuses.length > 0"
      style="max-height:265px;overflow-y:auto;overflow-x:hidden;">
      <label for="reasonForCloseCase" class="k-text-uppercase dark mb-0">{{'NEW-CHANNEL-WORKFLOW-STATUS' |
        translate}}</label>
      <div *ngFor="let item of workflowStatuses; let i = index;" class="row mb-2">
        <div class="col-7 pt-2 pr-0">
          <span class="montserrat">{{item.channel}} ({{item.program}})</span>
        </div>
        <div class="col-5">
          <kendo-combobox [filterable]="false" class="w-100" [data]="item.workflowStatuses" [textField]="'displayName'"
            [valueField]="'id'" [(ngModel)]="item.channelWorkflowStatusId" [valuePrimitive]="true"
            (valueChange)="channelWorkflowStatusIdChange($event, i)">
          </kendo-combobox>
        </div>
      </div>
    </div>
    <!--Open New Case-->
    <form *ngIf="enrollForm" [formGroup]="enrollForm">
      <!--Channel-->
      <div class="pl-1 pr-1">
        <hr />
        <label for="channelToEnroll" class="k-text-uppercase dark w-50">{{'OPEN-NEW-CASE' | translate}}
          <kendo-combobox [data]="groupedChannels" [textField]="'name'" [valueField]="'id'"
            [itemDisabled]="channelItemDisabled" [valuePrimitive]="false" formControlName="channelToEnroll">
          </kendo-combobox>
        </label>
      </div>
      <div class="pl-1 pr-1" *ngIf="channelToEnroll.value">
      </div>
      <div class="row pl-1 pr-1" *ngIf="channelToEnroll.value">
        <!--Enrollment Reason-->
        <div class="col-6 pr-0">
          <label class="k-form-field w-100">
            <span class="k-text-uppercase dark">
              {{'ENROLLMENT-REASON' | translate}} *
            </span>
            <input #enrollmentReason id="enrollmentReason" kendoTextBox maxlength="256"
              formControlName="enrollmentReason" />
            <div class="k-tooltip k-tooltip-validation" role="alert"
              *ngIf="enrollForm.controls['enrollmentReason'].invalid && enrollForm.controls['enrollmentReason'].touched">
              {{'REQUIRED-ENROLLMENT-REASON' | translate}}
            </div>
          </label>
        </div>
        <!--Manager-->
        <div class="col-6">
          <label class="k-form-field w-100">
            <span class="k-text-uppercase dark">
              {{'ASSIGN-CASE-MANAGER' | translate}} <span
                *ngIf="channelToEnroll !== undefined && channelToEnroll.value && channelToEnroll.value.caseManagerAssignmentMode === null">*</span>
            </span>
            <kendo-combobox #manager [filterable]="true" (filterChange)="handleCaseManagerFilter($event)"
              (close)="searchTerms=''" class="w-100" formControlName="manager" [data]="caseManagersFiltered"
              [placeholder]="'TYPE-OR-SELECT' | translate" [textField]="'name'" [valueField]="'id'"
              [itemDisabled]="itemDisabled">
              <ng-template kendoComboBoxItemTemplate let-dataItem>
                <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                </span>
              </ng-template>
            </kendo-combobox>
            <div class="k-tooltip k-tooltip-validation" role="alert"
              *ngIf="enrollForm.controls['manager'].invalid && enrollForm.controls['manager'].touched">
              {{'REQUIRED-MANAGER' | translate}}
            </div>
          </label>
        </div>
      </div>
      <!--Include Case Extensions-->
      <div class="pl-1 pr-1" *ngIf="channelToEnroll.value">
        <input type="checkbox" id="includeCaseExtensions" formControlName="includeCaseExtensions" kendoCheckBox />
        <label class="k-checkbox-label k-text-uppercase dark" for="includeCaseExtensions">
          {{ 'INCLUDE-CASE-EXTENSIONS' | translate}}
        </label>
      </div>
    </form>
  </div>
  <div>* {{'REQUIRED-FIELDS' | translate}}</div>
  <kendo-dialog-actions>
    <button kendoButton type="button" (click)="cancelCloseCases()">{{ 'CANCEL' | translate }}</button>
    <button appPreventClick kendoButton type="button" (click)="closeCases()"
      [disabled]="reasonForClose === null || reasonForClose.trim().length === 0">{{'SAVE' | translate}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- reassign cases dialog -->
<kendo-dialog *ngIf="reassignCasesDialogOpened" (close)="cancelReassignCases()" [minWidth]="450" [width]="900">
  <kendo-dialog-titlebar>
    <h3>{{'REASSIGN-CASES' | translate}}</h3>
  </kendo-dialog-titlebar>
  <div class="p-2">
    <!-- Assignee -->
    <div class="form-group pl-1 pr-1" *ngIf="channelsProcessedReassign.length > 0"
      style="max-height:265px;overflow-y:auto;overflow-x:hidden;">
      <label class="k-text-uppercase dark mb-0">{{'ASSIGNEE' |
        translate}} * </label>
      <div *ngFor="let item of channelsProcessedReassign; let i = index;" class="mb-2">
        <div class="row">
          <div class="col-7 pt-2 pr-0">
            <span class="montserrat">{{item.channel}} ({{item.program}})</span>
          </div>
          <div class="col-5">
            <kendo-combobox [filterable]="false" class="w-100" [data]="item.channelStaff" [textField]="'fullName'"
              [valueField]="'id'" [(ngModel)]="item.channelAssigneeId" [valuePrimitive]="true"
              [itemDisabled]="itemDisabled" (valueChange)="allAssigneesSelected()">
            </kendo-combobox>
          </div>
        </div>
        <div class="row"
          *ngIf="item !== undefined && item.channelStaff !== undefined && item.channelStaff.length === 0">
          <div class="col-1" style="max-width:45px!important">
            <i class="fas fa-exclamation-triangle icon-warn mt-2"></i>
          </div>
          <div class="col-11 pl-0 pt-2" style="line-height: 1em;">
            <span class="montserrat icon-warn text-center warn-modal-text">
              {{'NO-ASSIGNEE-INFO' | translate: patientLabel}}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group pl-1 pr-1 mb-0">
      <label for="reasonFoReassignCase" class="k-text-uppercase dark w-100">{{'REASON-FOR-REASSIGN-CASES' | translate}}
        *
        <textarea id="reasonFoReassignCase" required class="w-100" kendoTextArea rows="3"
          [(ngModel)]="reasonForReassign" style="max-height: 400px;" maxlength="512">
      </textarea>
      </label>
    </div>
    <!--Reassigned Open Tasks-->
    <div class="form-group pl-1 pr-1">
      <input type="checkbox" id="reassignOpenTasks" [(ngModel)]="reassignOpenTasksNgModel" kendoCheckBox />
      <label class="k-checkbox-label k-text-uppercase dark" for="reassignOpenTasks">{{
        'REASSIGN-OPEN-TASKS' | translate
        }}
      </label>
    </div>
  </div>
  <div>* {{'REQUIRED-FIELDS' | translate}}</div>
  <kendo-dialog-actions>
    <button kendoButton type="button" (click)="cancelReassignCases()">{{ 'CANCEL' | translate }}</button>
    <button appPreventClick kendoButton type="button" (click)="reassignCases()"
      [disabled]="reasonForReassign === null || reasonForReassign.trim().length === 0 || !allAssigneesSelected()">
      {{'SAVE' | translate}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>